import ServiceBase from './serviceBase';
import {
  FlowCreate,
  FlowContainer,
  FlowNextReview,
  FlowFeedbackProvided,
  OperFlowService,
  FlowFeedbackForSave,
  InviteReviewers,
  FlowRestart,
  FlowRelate,
  FlowReviewerDelete,
  FlowEsapInfo,
  FlowSprMission,
  FlowSprDoc,
} from './types/Flow';

class OperSupervisionReportEspfService extends ServiceBase implements OperFlowService {
  create = async (data: FlowCreate): Promise<number> =>
    this.post<number>('operationsrespf/create', data);

  getFlow = async (operationId: number): Promise<FlowContainer> =>
    this.get<FlowContainer>(`operationsrespf/${operationId}`);

  sendForNextReview = async (data: FlowNextReview): Promise<void> =>
    this.post<void>('operationsrespf/next', data);

  provideFeedback = async (data: FlowFeedbackProvided): Promise<void> =>
    this.post<void>('operationsrespf/feedback', data);

  saveFeedback = async (data: FlowFeedbackForSave): Promise<void> =>
    this.post<void>('operationsrespf/savefeedback', data);

  applyComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsrespf/${flowId}/applycompliance`);

  discardComplianceChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsrespf/${flowId}/discardcompliance`);

  applyActionPlanChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsrespf/${flowId}/applyactionplans`);

  discardActionPlanChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsrespf/${flowId}/discardactionplans`);

  applyIndicatorsChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsrespf/${flowId}/applyindicators`);

  discardIndicatorsChanges = async (flowId: number): Promise<void> =>
    this.post<void>(`operationsrespf/${flowId}/discardindicators`);

  openWord = async (flowId: number): Promise<string> =>
    this.post<string>(`operationsrespf/${flowId}/wordlink`);

  downloadDocVersion = async (id: number): Promise<boolean> => {
    await this.download(`operationsrespf/version/${id}`);
    return true;
  };

  upload = async (formData: FormData): Promise<boolean> => {
    const result = await this.post<boolean>('operationsrespf/upload', formData);
    return result;
  };

  restart = async (data: FlowRestart): Promise<void> =>
    this.post<void>('operationsrespf/restart', data);

  relate = async (data: FlowRelate): Promise<void> =>
    this.post<void>('operationsrespf/relate', data);

  inviteReviewers = async (data: InviteReviewers): Promise<void> =>
    this.post<void>('operationsrespf/invite-reviewers', data);

  removeReviewers = async (data: FlowReviewerDelete): Promise<void> =>
    this.post<void>('operationsrespf/remove-reviewers', data);

  getSPRRationale = async (flowId: number): Promise<FlowSprDoc> =>
    this.get<FlowSprDoc>(`operationsrespf/${flowId}/sprrationale`);

  getSPRMissions = async (flowId: number): Promise<FlowSprMission[]> =>
    this.get<FlowSprMission[]>(`operationsrespf/${flowId}/sprmissions`);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  checkEsap = async (flowId: number): Promise<FlowEsapInfo> =>
    this.get<FlowEsapInfo>(`operationsrespf/check-esap/${flowId}`);

  deleteFlow = async (flowId: number, lap?: number | undefined) => {
    let uri = `operationsrespf/${flowId}`;
    if (lap) {
      uri = `${uri}/${lap}`;
    }
    return this.delete<void>(uri);
  };
}

const operSupervisionReportEspfService = new OperSupervisionReportEspfService();

export default operSupervisionReportEspfService;
